<template>
  <b-row no-gutters class="source_nav">
    <b-col>
      <div v-if="prev_section">
        <router-link :to="'/source/' + prev_section.section">
          <span v-html="prev_section.title" />
        </router-link>
      </div>
    </b-col>

    <b-col>
      <router-link to="/source/">
        <b>Home</b>
      </router-link>
    </b-col>

    <b-col>
      <div v-if="next_section">
        <router-link :to="'/source/' + next_section.section">
          <span v-html="next_section.title" />
        </router-link>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import index from '../assets/source.json'

export default {
  name: 'SourceNav',

  props : {
    section_index : Number
  },

  computed : {
    prev_section : function(){
      if(this.section_index == 0) return null;
      return index.sections[this.section_index-1];
    },

    next_section : function(){
      if(this.section_index == index.sections.length - 1) return null;
      return index.sections[this.section_index + 1];
    }
  }
}
</script>

<style scoped>
.source_nav{
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
  margin-bottom: 10px;
  background-color: #fbfbfb;
  border-bottom: 1px solid #c8c2c2;
  border-top: 1px solid #c8c2c2;
}

.source_nav a{
  color: black;
}
</style>
